export const SET_RFINDEXERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.rfIndexers.data = payload.map((item) => {
      return item.replace('(TAXA)%', 'TAXA')
    })
    state.rfIndexers.lastUpdate = new Date()
  }
}
export const SET_RFINDEXERS_LOADING = (state, payload) => {
  state.rfIndexers.loading = payload
}

export const SET_FEE_MODELS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.feeModels.data = payload
    state.feeModels.lastUpdate = new Date()
  }
}
export const ADD_FEE_MODELS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.feeModels.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.feeModels.data.push(data)
      }
    })
  }
}
export const SET_FEE_MODELS_LOADING = (state, payload) => {
  state.feeModels.loading = payload
}

export const SET_PORTFOLIO_MODELS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.portfolioModels.data = payload.sort((a, b) => {
      if (a.nome && b.nome) {
        return a.nome.localeCompare(b.nome)
      }
      return 0
    })
    state.portfolioModels.lastUpdate = new Date()
  }
}
export const ADD_PORTFOLIO_MODELS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.portfolioModels.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.portfolioModels.data.push(data)
      }
    })

    state.portfolioModels.data = state.portfolioModels.data.sort((a, b) => {
      if (a.nome && b.nome) {
        return a.nome.localeCompare(b.nome)
      }
      return 0
    })
  }
}
export const SET_PORTFOLIO_MODELS_LOADING = (state, payload) => {
  state.portfolioModels.loading = payload
}
export const SET_CURRENCIES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.currencies.data = payload
    state.currencies.lastUpdate = new Date()
  }
}
export const ADD_CURRENCIES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.currencies.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.currencies.data.push(data)
      }
    })
  }
}
export const SET_CURRENCIES_LOADING = (state, payload) => {
  state.currencies.loading = payload
}

